/** 
 * OrderingManager
 *
 * Created by Ripoche Sylvain on 10/13/2017
 * Last modification by Ripoche Sylvain on 10/13/2017
 * 
 * Order the result.
 * 
 */

const OrderingManager = (function() {
    // ================== VARIABLE ================== //
    var _callbacks = [];
    var _currentOrdering = 'default';
    var _sharingtype;
    var _orderingElement;

    // ================== CONSTRUCTOR ================== //
    function OrderingManager() {
        // Singleton
        if (OrderingManager.instance) {
            throw new Error('OrderingManager is a singleton. Use OrderingManager.instance.');
        }
        // enforces new
        if (!(this instanceof OrderingManager)) {
            return new OrderingManager();
        }
    };

    // ================== PUBLIC METHOD ================== //
    OrderingManager.prototype.init = function() {
        _orderingElement = $('.ordering-filter');
        _orderingElement.find('li').on('click', _onOrderingSelect);
    };

    OrderingManager.prototype.orderCruise = function(cruiseList, sharingType) {
        _sharingtype = sharingType;
        switch (_currentOrdering) {
            case 'default':
            case 'rating-down':
                cruiseList.sort(_bestRating);
                break;
            case 'leads-down':
                cruiseList.sort(_bestLeads);
                break;
            case 'duration-up':
                cruiseList.sort(_durationUp);
                break;
            case 'duration-down':
                cruiseList.sort(_durationDown);
                break;
            case 'price-up':
                cruiseList.sort(_priceUp);
                break;
            case 'price-down':
                cruiseList.sort(_priceDown);
                break;
        }
    };

    OrderingManager.prototype.onOrderingChange = function(callback, target) {
        _callbacks.push({
            'callback': callback,
            'target': target
        });
    };


    OrderingManager.prototype.changeOrdering = function(value) {
        _currentOrdering = value;
        _onOrderingSelect();
    };

    // ================== PRIVATE METHOD ================== //

    // Compare cruise (duration then id) accending
    function _durationUp(a, b) {
        var r = a.duration - b.duration;
        if (r == 0)
            return a.id > b.id ? 1 : -1;
        return r
    }

    // Compare cruise (duration then id) decending
    function _durationDown(a, b) {
        var r = b.duration - a.duration;
        if (r == 0)
            return a.id > b.id ? 1 : -1;
        return r
    }

    // Compare cruise (rating then id) decending
    function _bestRating(a, b) {
        var r = b.rating - a.rating;
        if (r == 0) {
            r = b.review_count - a.review_count;
            if (r == 0)
                return a.id > b.id ? 1 : -1;
        }
        return r
    }

    // Compare cruise (leads then id) decending
    function _bestLeads(a, b) {
        var r = b.leads - a.leads;
        if (r == 0)
            return a.id > b.id ? 1 : -1;
        return r
    }

    // Compare cruise (price then id) decending
    function _priceDown(a, b) {
        if (_sharingtype == 'shared')
            var r = b.min_shared_price.min - a.min_shared_price.min;
        else
            var r = b.min_private_price.min - a.min_private_price.min;
        if (r == 0)
            return a.id > b.id ? 1 : -1;
        return r
    }

    // Compare cruise (price then id) accending
    function _priceUp(a, b) {
        if (_sharingtype == 'shared')
            var r = a.min_shared_price.min - b.min_shared_price.min;
        else
            var r = a.min_private_price.min - b.min_private_price.min;
        if (r == 0)
            return a.id > b.id ? 1 : -1;
        return r
    }


    // ================== EVENT ================== //
    function _onOrderingSelect(event) {
        // Get the ordering from the input
        _currentOrdering = $(event.target).data('ordering');
        window.searchState.ordering = _currentOrdering;

        // Change the display of the button :
        _orderingElement.find('.text-button:not(.default)').html($(event.target).html());
        
        // Call callbacks
        for (var i = 0; i < _callbacks.length; i++) {
            _callbacks[i].callback.apply(_callbacks[i].target);
        }
    }

    OrderingManager.instance = new OrderingManager();

    return OrderingManager.instance;
})();

export default OrderingManager


// WEBPACK FOOTER //
// ./search/static/search/js/orderingManager.js